// $(window).on('load', function() {
// 	if (judgeme._doneSetup) {
// 	  //Replace all review values greater than 999 with local number format
// 	  $('.jdgm-prev-badge').each(function() {
// 	  	var numberReviews = $(this).attr('data-number-of-reviews');

// 	  	if (numberReviews.length > 3) {
// 		  	const intReviews = parseInt( numberReviews, 10);
// 	  		$(this).find('.jdgm-prev-badge__text').text( intReviews.toLocaleString() + " reviews" );
// 	  	}
// 	  });
// 	}
// }); 

// ////////////////////////////////////
// ADJUST SVG BADGES SIZES RESPONSIVELY
// ////////////////////////////////////
const adjustBadgeSVG = () => {
	const viewWidth = window.innerWidth;
	if(viewWidth <= 360) {
	  $(".badge-bestseller, .badge-limitedSupply").attr('width', '86').attr('height', '86').attr('viewBox', '0 0 72 70')
	} else if (viewWidth <=  554.98) {
	  $(".badge-bestseller, .badge-limitedSupply").attr('width', '56').attr('height', '56').attr('viewBox', '0 0 72 70')
	} else if (viewWidth <=  749.98) {
		$(".badge-bestseller, .badge-limitedSupply").attr('width', '92').attr('height', '92').attr('viewBox', '0 0 72 70')
	} else if (viewWidth <= 869.98) {
		$(".badge-bestseller, .badge-limitedSupply").attr('width', '70').attr('height', '70').attr('viewBox', '0 0 72 70')
	} else if (viewWidth <= 989.98) {
		$(".badge-bestseller, .badge-limitedSupply").attr('width', '80').attr('height', '80').attr('viewBox', '0 0 72 70')
	} else {
	  $(".badge-bestseller, .badge-limitedSupply").attr('width', '70').attr('height', '70').attr('viewBox', '0 0 72 70')
	}
  }
window.addEventListener('resize', adjustBadgeSVG);
adjustBadgeSVG()




// ////////////////////////////
// DRAG SCROLL FILTER - DESKTOP
// ////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
	const ele = document.querySelector('.filter-scrolling');
	if (!ele) return;
	
	ele.style.cursor = 'grab';

	let pos = { top: 0, left: 0, x: 0, y: 0 };

	const mouseDownHandler = function (e) {
		ele.style.cursor = 'grabbing';
		ele.style.userSelect = 'none';

		pos = {
			left: ele.scrollLeft,
			// top: ele.scrollTop,
			// Get the current mouse position
			x: e.clientX,
			// y: e.clientY,
		};

		document.addEventListener('mousemove', mouseMoveHandler);
		document.addEventListener('mouseup', mouseUpHandler);
	};

	const mouseMoveHandler = function (e) {
		// How far the mouse has been moved
		const dx = e.clientX - pos.x;
		// const dy = e.clientY - pos.y;

		// Scroll the element
		// ele.scrollTop = pos.top - dy;
		ele.scrollLeft = pos.left - dx;
	};

	const mouseUpHandler = function () {
		ele.style.cursor = 'grab';
		ele.style.removeProperty('user-select');

		document.removeEventListener('mousemove', mouseMoveHandler);
		document.removeEventListener('mouseup', mouseUpHandler);
	};

	// Attach the handler
	ele.addEventListener('mousedown', mouseDownHandler);
});




// Add to cart

$('.btn-add-to-cart a').on('click', function(e) {
	e.preventDefault();
	const variantId = $(this).data('variantid');
	const productLink = $(this).closest('.product-grid-item').find('.product-grid-item--link').attr('href');
	
	$(this).addClass('loading')

	CartJS.addItem(variantId, 1, {}, {
		"success": function(data, textStatus, jqXHR) {
			console.log('Item added to the cart');
			// window.location.reload()
			cartCountHotFix();
			$('.btn-add-to-cart a').removeClass('loading')
		},
		"error": function(jqXHR, textStatus, errorThrown) {
			jqXHR.responseJSON && console.log(`CartJS.addItem() Error: ${jqXHR.responseJSON.description}`);
			$('.btn-add-to-cart a').removeClass('loading')

			displayAlert(`${jqXHR.responseJSON.description} <a href="${productLink}">Sign up to be notified when it's back in stock</a>`);
		}
	});
})



function cartCountHotFix() {
	let cartCount = 1;
	const counter = $('.cart__number').eq(0);
	if(counter.length) {
		cartCount = parseInt(counter.text());
		$('.cart__number').each(function() {
			$(this).html(cartCount +1);
		})
	}
	else {
		const html = `
			<span data-cart-view="data-cart-view" rv-show="cart.item_count | gt 0 "><span class="cart__number" rv-text="cart.item_count">${ cartCount }</span></span> 
		`;
		$('.header__cart__link').each(function() {
			$(this).append(html);
		})
	}
	
	displayAlert()
}

function displayAlert(message = 'Item added to cart') {
	if (!$('.toast-container').length) {
	  $('body').append('<div class="toast-container"></div>');
	}
  
	const $toast = $('<div class="toast"></div>').html(message);
	$('.toast-container').append($toast);
  
	setTimeout(() => $toast.addClass('show'), 10);
  
	setTimeout(() => {
	  $toast.removeClass('show');
	  setTimeout(() => $toast.remove(), 300);
	}, 3000);
}